module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_yoyaku-1ce8a37afb6c9ba82fba1827621d0dca.png";